import { Box, Button, Text, TextInput, DataTable, Select } from "grommet";
import React, { useEffect, useState, useRef } from "react";
import "./Passengers.css";
import searchIcon from "../../../../../../assets/search.svg";
import formicon from "../../../../../../assets/form(2).svg";
import editsquare from "../../../../../../assets/edit.png";
import view from "../../../../../../assets/veiw.svg";
import NoDataFound from "../../../../../../assets/urban-no-data-found-3 1.png";
import { useStore } from "../../../../../../Hooks/useStore";
import AddPassengers from "./AddPassengers";
import { observer } from "mobx-react";
import PassengerService from "../../../../../../services/passenger/passenger.service";
import { json, Navigate, useNavigate } from "react-router-dom";
import { PassengerStore } from "../../../../../../store/PassengerStore";
import createFlightService from "../Users/CreateFlight/create-flight.service";
import { makeObservable, observable } from "mobx";
import Pagination from "../../../common/Pagination/Pagination";
import EditPassengersDetails from "./EditPassengersDetails";
import usersService from "../Users/users.service";
import userActionDropdown from "../../../../../../assets/arrow_drop_down (1).svg";

const Passengers = observer(() => {
  const { rootStore } = useStore();
  const navigate = useNavigate();
  

  // const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortedPassengerList, setSortedPassengerList] = useState([]);
  const [itemsPerPage] = useState(10); // Define the number of items per page
  const [originalPassengersList, setOriginalPassengersList] = useState([]);
  // const [sortedPassengersList, setSortedPassengersList] = useState([]);
  const [searchString, setSearchString] = useState("");

  const clearFormStates = () => {
    rootStore.passengerStore.handleEditPassengersName("");
    rootStore.passengerStore.handleEditPassengerAge("");
    rootStore.passengerStore.handleEditPassengerEmail("");
    rootStore.passengerStore.handleEditPassengerAdress("");
    rootStore.passengerStore.handleEditPassengersContactNumber("");
    rootStore.passengerStore.handleEditPassengerAnyChronicDisease(false);
    rootStore.passengerStore.handleEditPassengerAnyChronicDisease1("");
    rootStore.passengerStore.handleEditPassengerPhysicallyDisabled(false);
    rootStore.passengerStore.handleEditPassengerInput0(false);
    rootStore.passengerStore.handleEditPassengerInput00("");
    rootStore.passengerStore.handleEditPassengerInput1("");
    rootStore.passengerStore.handleEditPassengerInput2("");
    rootStore.passengerStore.handleEditPassengerInput3("");
    rootStore.passengerStore.handleEditPassengerInput4("");
    rootStore.passengerStore.handleEditPassengerInput5(false);
    rootStore.passengerStore.handleEditPassengerInput05("");
    rootStore.passengerStore.handleEditPassengerInput6(false);
    rootStore.passengerStore.handleEditPassengerInput06("");
  };
  useEffect(() => {
    // Logic to determine which form to show based on navigation or other conditions
    // For simplicity, assuming initial state or navigation logic
    rootStore.passengerStore.handlChangeEditForm(true); // Show first form initially when component mounts
  }, []);
  useEffect(() => {
    // Logic to determine which form to show based on navigation or other conditions
    // For simplicity, assuming initial state or navigation logic
    rootStore.passengerStore.handlChangeForm(true); // Show first form initially when component mounts
  }, []);

  const onViewClick = (passengerId) => {
    navigate(`/passenger-details/${passengerId}`)
  }

  const handleftfForm = async (PassengerIdPassenger) => {
    try {
      rootStore.passengerStore.handlePassengerId(PassengerIdPassenger);
      const passengerResponse = await PassengerService.getPassenger(PassengerIdPassenger);
      
      navigate(`../../FitToFlyflow`, {
        state: {
          passenger: passengerResponse
        }
      });
      
      return passengerResponse;
    } catch (error) {
      console.error("Error fetching passenger:", error);
    }
  };
  

  const handleEditPassenger = async (PassengerIdPassenger) => {
    clearFormStates();
    try {
      rootStore.passengerStore.handlePassengerId(PassengerIdPassenger);
      const PassengerResponse = await PassengerService.getPassenger(PassengerIdPassenger);
      console.log("PassengerResponse",PassengerResponse);
      rootStore.passengerStore.handleEditPassengersName(PassengerResponse.name);
      rootStore.passengerStore.handleEditPassengerEmail(PassengerResponse.email);
      rootStore.passengerStore.handleEditPassengerAge(PassengerResponse.age);
      rootStore.passengerStore.handleEditPassengerAdress(PassengerResponse.address);
      rootStore.passengerStore.handleEditPassengersGenger(PassengerResponse.gender);
      rootStore.passengerStore.handleEditPassengersContactNumber(PassengerResponse.contactNumber);
      rootStore.passengerStore.handleSelectedOrgId(PassengerResponse.orgId);

      let response = await PassengerService.getQuestionList();
      console.log("passenger history question", response);
      response.map(async (question) => {
        console.log(question.id);
        let answere = await PassengerService.getAnswereById(PassengerIdPassenger, question.id);
        if (answere.length > 0) {
          switch (question.id) {
            case 3:
              rootStore.passengerStore.handleEditPassengerAnyChronicDisease(!(answere[0]?.answer == "" || answere[0]?.answer.toLowerCase() == "no"));
              rootStore.passengerStore.handleEditPassengerAnyChronicDisease1(answere[0]?.answer.toLowerCase() == "no" ? "" : answere[0]?.answer);
              break;
            case 4:
              rootStore.passengerStore.handleEditPassengerPhysicallyDisabled(!(answere[0]?.answer == "" || answere[0]?.answer.toLowerCase() == "no"));
              rootStore.passengerStore.handleEditPassengerPhysicallyDisabledAns(answere[0]?.answer.toLowerCase() == "no" ? "" : answere[0]?.answer)
              break;
            case 5:
              rootStore.passengerStore.handleEditPassengerInput0(answere[0]?.answer);
              rootStore.passengerStore.handleEditPassengerInput00(answere[0]?.answer);
              break;
            case 6:
              rootStore.passengerStore.handleEditPassengerInput1(answere[0]?.answer);
              break;
            case 7:
              rootStore.passengerStore.handleEditPassengerInput3(answere[0]?.answer);
              break;
            case 8:
              rootStore.passengerStore.handleEditPassengerInput4(answere[0]?.answer.toLowerCase());
              break;
            case 9:
              rootStore.passengerStore.handleEditPassengerInput5(!(answere[0]?.answer == ""));
              rootStore.passengerStore.handleEditPassengerInput05(answere[0]?.answer);
              break;
            case 10:
              rootStore.passengerStore.handleEditPassengerInput6(answere[0]?.answer);
              rootStore.passengerStore.handleEditPassengerInput06(answere[0]?.answer);
              break;
            default:
              break;
          }
        } else {
          switch (question.id) {
            case 3:
              rootStore.passengerStore.handleEditPassengerAnyChronicDisease(false);
              rootStore.passengerStore.handleEditPassengerAnyChronicDisease1("");
              break;
            case 4:
              rootStore.passengerStore.handleEditPassengerPhysicallyDisabled(false);
              rootStore.passengerStore.handleEditPassengerPhysicallyDisabledAns("")
              break;
            case 5:
              rootStore.passengerStore.handleEditPassengerInput0(false);
              rootStore.passengerStore.handleEditPassengerInput00("");
              break;
            case 6:
              rootStore.passengerStore.handleEditPassengerInput1("");
              break;
            case 7:
              rootStore.passengerStore.handleEditPassengerInput3("");
              break;
            case 8:
              rootStore.passengerStore.handleEditPassengerInput4("");
              break;
            case 9:
              rootStore.passengerStore.handleEditPassengerInput5(false);
              rootStore.passengerStore.handleEditPassengerInput05("");
              break;
            case 10:
              rootStore.passengerStore.handleEditPassengerInput6(false);
              rootStore.passengerStore.handleEditPassengerInput06("");
              break;
            default:
              break;
          }
        }
      });
      rootStore.passengerStore.handleIsEditPassengerOpen(true);
    } catch (error) {
      console.log("Error fetching passenger data:", error);
    }
  };

  useEffect(() => {
    setOriginalPassengersList(rootStore.passengerStore.getPassengers);
  }, []);

  const [searchQuery, setSearchQuery] = useState(""); // To handle search query state
const [dropdownOpen, setDropdownOpen] = useState(false);

  const organizationList = async () => {
    let organizations = await usersService.listOrganizations();
    rootStore.passengerStore.handleOrgList(organizations);
  };
  useEffect(() => {
    organizationList();
  }, []);

  const filteredOptions = [
    ...rootStore.passengerStore.getOrgList,
    { id: '', name: 'Select All' }
  ].filter(org => org.name.toLowerCase().includes(searchQuery.toLowerCase())); // Filter options based on the search query
  const [dropdownText1, setDropdownText1] = useState("Select All");

  let userInfo;

  useEffect(() => {
    (async () => {
      let userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        let username = JSON.parse(userInfo).username;
        rootStore.passengerStore.handlePassengerLabel(username);
        rootStore.passengerStore.handleRoleName(
          JSON.parse(userInfo).roleLabel.toLowerCase()
        );
        if (JSON.parse(userInfo).roleLabel.toLowerCase() == "admin") {
          let userOrg = await createFlightService.getOrgByUserName(username);
          rootStore.passengerStore.handleSelectedOrg(userOrg.id);
        }
      }
    })();
  }, []);

  useEffect(() => {
    rootStore.loadingStore.setShowLoader(true);
    setTimeout(() => {
      getPassengers(rootStore.passengerStore.getSelectedOrg);
    },2000);
  }, [
    rootStore.passengerStore.getupdate,
    rootStore.passengerStore.getSelectedOrg,
  ]);

  const getPassengers = async (id) => {
    try {
      const PassengerData = await PassengerService.listAllPassenger(id);
      rootStore.passengerStore.handlePassengers(PassengerData);
      setOriginalPassengersList(PassengerData);
      // setSortedPassengersList(PassengerData.slice(0, itemsPerPage)); // Initialize sorted list with first page
      rootStore.loadingStore.setShowLoader(false);
    } catch (error) {
      console.error("Error fetching flights:", error);
    }
    // getPassengers();
  };

  const ShowAddPassenger = () => {
    rootStore.passengerStore.handlePassengersName("");
    rootStore.passengerStore.handlePassengerAge("");
    rootStore.passengerStore.handlePassengerEmail("");
    rootStore.passengerStore.handlePassengerAddress("");
    rootStore.passengerStore.handlePassengersContactNumber("");
    rootStore.passengerStore.handlePassengerAnyChronicDisease(false);
    rootStore.passengerStore.handlePassengerAnyChronicDisease1("");
    rootStore.passengerStore.handlePassengerPhysicallyDisabled("");
    rootStore.passengerStore.handlePassengerInput0(false);
    rootStore.passengerStore.handlePassengerInput00("");
    rootStore.passengerStore.handlePassengerInput1("");
    rootStore.passengerStore.handlePassengerInput2("");
    rootStore.passengerStore.handlePassengerInput3("");
    rootStore.passengerStore.handlePassengerInput4("");
    rootStore.passengerStore.handlePassengerInput5(false);
    rootStore.passengerStore.handlePassengerInput05("");
    rootStore.passengerStore.handlePassengerInput6(false);
    rootStore.passengerStore.handlePassengerInput06("");

    // rootStore.passengerStore.handleAddPassenger(true);
    navigate("addPassengers");
  };

  const getParameters = (data) => {
    return {
      any_chronic_disease: data.passengerStatusQuestions.find(
        (q) => q.question === "any_chronic_disease"
      ).response,
      physically_disabled: data.passengerStatusQuestions.find(
        (q) => q.question === "physically_disabled"
      ).response,
    };
  };

  const onSearchStrChange = (value) => {
    setSearchString(value);
    if (value.trim() === "") {
      rootStore.passengerStore.handlePassengers(originalPassengersList);
      setSortedPassengerList(
        originalPassengersList.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      );
    }
  };

  const onSearch = (value) => {
    const filteredPassengers = originalPassengersList.filter((item) => {
      let matches = false;

      if (item.name && item.name.toLowerCase().includes(value.toLowerCase())) {
        matches = true;
      }
      if (
        item.age &&
        String(item.age).toLowerCase().includes(value.toLowerCase())
      ) {
        matches = true;
      }
      if (
        item.orgId &&
        String(item.orgName).toLowerCase().includes(value.toLowerCase())
      ) {
        matches = true;
      }
      if (
        item.gender &&
        item.gender.toLowerCase().includes(value.toLowerCase())
      ) {
        matches = true;
      }

      return matches;
    });

    rootStore.passengerStore.handlePassengers(filteredPassengers);
    setSortedPassengerList(filteredPassengers.slice(0, itemsPerPage));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSortedPassengerList(
      originalPassengersList.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      )
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch(searchString); // Trigger search when Enter key is pressed
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visiblePassengersList = rootStore.passengerStore.getPassengers.slice(
    startIndex,
    endIndex
  );

  // Handle outside click
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false); // Close the dropdown
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);


  const handleFitToFlyView = async (passengerId) => {
    try {
      const passengerResponse = await PassengerService.getPassenger(passengerId);
      navigate(`../../fittofly-view/${passengerId}`, {
        state: { passenger: passengerResponse },
      });
    } catch (error) {
      console.error("Error loading passenger:", error);
    }
  };



  return (
    <Box className="passengers-container">
      <Box className="passengers-header">
        <Box className="passengers-left-header">
          <Box className="passengers-search-modal">
            <TextInput
              className="passengers-search-input"
              onChange={(e) => onSearchStrChange(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Search"
            />
            <img src={searchIcon} className="searchIcon" />
          </Box>
          <Button
            className="passengers-search-btn"
            label="Search"
            onClick={() => onSearch(searchString)}
          />
        </Box>
        <Box className="passengers-right-header">
    {rootStore.passengerStore.getRolename !== 'admin' ? (
      <div style={{ maxHeight: '40px' }}>
        {/* Button that triggers the dropdown */}
        <Button
          style={{
            display: 'flex',
            width: '148px',
            padding: '8px 8px 8px 12px',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '8px',
            border: '1px solid rgb(237 237 235)',
            color: '#4B628A',
            fontFamily: 'Inter',
            fontSize: '13px',
            fontStyle: 'normal',
            fontWeight: '520',
            lineHeight: '20px',
            backgroundColor: '#eafbfa',
          }}
          className="users-action-btn"
          onClick={() => setDropdownOpen(!dropdownOpen)} // Toggle dropdown visibility
        >
          {dropdownText1} {/* Display current dropdown text */}
          <img
            style={{
              width: '24px',
              height: '24px',
              flexShrink: '0',
              transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
            src={userActionDropdown} // Make sure `userActionDropdown` is defined
            alt="Dropdown Icon"
          />
        </Button>

        {/* Dropdown Menu */}
        {dropdownOpen && (
          <div
            ref={dropdownRef}
            className="dropdown-menu"
            style={{
              position: 'relative',
              top: '23.5%',
              width: '148px',
              backgroundColor: '#fff',
              border: '1px solid #ddd',
              zIndex: '1',
              borderRadius: '10px',
            }}
          >
            {/* Search Input */}
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search..."
              style={{
                width: '100%',
                padding: '8px',
                borderRadius: '8px 8px 0 0',
                border: '1px solid #ccc',
                marginBottom: '5px',
              }}
            />

            {/* Filtered Paragraphs/Organizations */}
            <div
              style={{
                fontSize: '14px',
                width: '100%',
                maxHeight: '325px',
                overflowY: 'scroll',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
            >
              {filteredOptions.map((org) => (
                <p
                  onClick={() => {
                    const orgId = org.id;
                    rootStore.passengerStore.handleSelectedOrg(orgId); // Handle org selection
                    setDropdownText1(org.name);
                    setDropdownOpen(false); // Close dropdown after selection
                  }}
                  data-org-id={org.id}
                  className="pointer"
                  key={org.id}
                >
                  {org.name}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    ) : (
      <Button style={{ display: 'none' }} />
    )}

    {/* Add Passenger Button */}
    <Button
      className="add-passengers-btn"
      label="Add Passenger’s Detail"
      onClick={ShowAddPassenger}
    />
  </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          className="passengers-table-container"
          style={{ height: visiblePassengersList.length > 0 ? "calc(100% - 48px)" : "auto"}}
        >
          <DataTable
            data={visiblePassengersList}
            resizeable
            className="passengers-datatable"
            paginate={true}
            step={itemsPerPage}
            columns={[
              {
                align: "center",
                property: "name",
                header: <Text>Passenger’s Name</Text>,
                primary: true,
                render: (item) => <Text>{item.name}</Text>,
              },
              {
                align: "center",
                property: "age",
                header: <Text>Age</Text>,
                primary: true,
                render: (item) => <Text>{item.age}</Text>,
              },
              {
                align: "center",
                property: "gender",
                header: <Text>Gender</Text>,
                primary: true,
                render: (item) => <Text>{item.gender}</Text>,
              },
              ...(rootStore.passengerStore.getRolename !== "admin"
                ?
                [
                  {
                    align: "center",
                    property: "orgName",
                    header: <Text>Organization</Text>,
                    primary: true,
                    render: (item) => <Text>{item.orgName}</Text>,
                  }
                ]
                :
                []
              ),
              {
                property: "chronicDisease",
                header: (
                  <Text style={{ textAlign: "center" }}>Chronic Condition</Text>
                ),
                align: "center",
                primary: true,
                render: (item) => {
                  return (
                    <Text
                      style={{ textAlign: "center" }}
                    >
                      {item.chronicDisease || "NO"}
                    </Text>
                  );
                },
              },
              {
                property: "physicallyDisabled",
                header: (
                  <Text style={{ textAlign: "center" }}>Impairments</Text>
                ),
                align: "center",
                primary: true,
                render: (item) => {
                  return (
                    <Text
                      style={{ textAlign: "center" }}
                    >
                      {item.physicallyDisabled || "NO"}
                    </Text>
                  );
                },
              },

              {
                align: "center",
                property: "edit",
                header: <Text>Details</Text>,
                primary: true,
                render: (item) => (
                  <Box
                  direction="row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 12
                    }}
                  >
                  <button style={{cursor:"pointer"}} className="details-btn" onClick={() => onViewClick(item.passengerId)}>
                    <img src={view} style={{height: 11, width: 16}} alt="View" />
                  </button>
                  <button style={{cursor:"pointer"}} className="details-btn" onClick={() => handleEditPassenger(item.passengerId)}>
                    <img src={editsquare} style={{height: 16, width: 16}} alt="Edit" />
                  </button>
                  </Box>
                ),
              },
              {
                align: "center",
                property: "edit",
                header: <Text>Fit-to-Fly</Text>,
                primary: true,
                render: (item) => (
                  <Box
                  direction="row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 12
                    }}
                  >
                  <button title="View Fit-to-Fly" style={{cursor:"pointer"}} className="details-btn" onClick={() => handleFitToFlyView(item.passengerId)}>
                    <img src={view} style={{height: 11, width: 16}} alt="View" />
                  </button>
                  <button title="Fit-to-Fly Form" style={{cursor:"pointer"}} className="details-btn" onClick={() => handleftfForm(item.passengerId)}>
                    <img src={formicon} style={{height: 16, width: 16}} alt="FTF Form" />
                  </button>
                  
                  </Box>
                ),
              },
            ]}
          />
        </Box>
        <Box
          className="passengers-pagination-container"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          {rootStore.passengerStore.getPassengers.length > itemsPerPage && (
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(
                rootStore.passengerStore.getPassengers.length / itemsPerPage
              )}
              totalItems={rootStore.passengerStore.getPassengers.length}
              onPageChange={handlePageChange}
              style={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "white",
                zIndex: 1,
                marginTop: "auto",
              }}
            />
          )}
        </Box>
      </Box>

      {visiblePassengersList.length === 0 ? (
        <div className="spinner-container">
          
            <img src={NoDataFound}/>
            <p>No Data Found</p>
        </div>
      ) : (
        <></>
      )}

      {rootStore.passengerStore.getIsEditPassengerOpen && (
        <EditPassengersDetails />
      )}
    </Box>
  );
});

export default Passengers;
